var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { debugRoot } from '../../../../styles/debugStyles';
var itemLayoutStyles = {
    root: function (_a) {
        var props = _a.props, variables = _a.variables;
        var debugLayout = props.debugLayout;
        return __assign({}, (debugLayout && debugRoot()), { gridTemplateRows: "minmax(" + variables.height + ", max-content)", paddingLeft: variables.paddingLeft, paddingRight: variables.paddingRight });
    },
};
export default itemLayoutStyles;
